import React, { useContext } from "react";
import ArenkoUIAlertSnackbar from "@arenko-group/arenko-ui/dist/components/AlertSnackbar";
import { DataTestContext } from "@arenko-group/arenko-ui/dist/components/AuthorisedApp";
import { closeSnackbar } from "@/features/alertSnackbarSlice";
import { useAppDispatch, useAppSelector } from "@/storeHooks";

const AlertSnackbar = () => {
  const dataTestId = useContext(DataTestContext);
  const dispatch = useAppDispatch();
  const snackbarOpen = useAppSelector((state) => state.snackbar.snackbarOpen);
  const snackbarAutoCloseDuration = useAppSelector(
    (state) => state.snackbar.snackbarAutoCloseDuration
  );
  const alertSeverity = useAppSelector((state) => state.snackbar.alertSeverity);
  const alertMessage = useAppSelector((state) => state.snackbar.alertMessage);
  const disableClickaway = useAppSelector(
    (state) => state.snackbar.disableClickaway
  );

  const handleClose = (_event?: unknown, reason?: string) => {
    if (disableClickaway && reason === "clickaway") {
      return;
    }
    dispatch(closeSnackbar());
  };

  return (
    <ArenkoUIAlertSnackbar
      dataTestId={dataTestId}
      position={{ vertical: "top", horizontal: "right" }}
      open={snackbarOpen}
      autoHideDuration={snackbarAutoCloseDuration}
      onClose={handleClose}
      alertSeverity={alertSeverity}
      alertMessage={alertMessage}
    />
  );
};

export default AlertSnackbar;
